<template>
  <div>
    <template>
      <v-card class="mx-auto" >
        <v-toolbar color="primary" dark>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                   <v-spacer></v-spacer>
                   <v-btn color="white black--text " @click="close">
              close
            </v-btn> 
           </v-toolbar>
      </v-card>
  </template>      
    <v-card>
    
     <v-container class="fixWidth">
       <v-form ref="formVal" lazy-validation>
            <v-row>
            <v-col cols="12"
                sm="6"
                md="6">
              <v-autocomplete
                    name="Title"
                    :item-text="item => item.en_name"
                    item-value="division_code"
                    v-model="getSchema.division_code"
                    chips
                    :items="getDivisionItem"
                    :rules="generalRules"
                  >
                  <template v-slot:label>
                  Division Name<strong style="color: red">*</strong>
                </template>
                  <template v-slot:selection="data">
                    <v-chip
                      color="grey lighten-4"
                      :input-value="data.selected"
                    >
                      <span class="subheading">{{
                        data.item.en_name
                      }}</span>
                    </v-chip>
                  </template>
                </v-autocomplete>
               
            </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="beside-drop-down"
              >
                <v-text-field
                  v-model="getSchema.bn_name"
                  required
                  :rules="generalRules.concat(banglaRules)"
                >
                <template v-slot:label>
                  District Name (Bangla)<strong style="color: red">*</strong>
                </template>
                </v-text-field>
               
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="getSchema.en_name"
                  :rules="generalRules"
                >
                <template v-slot:label>
                  District Name (English)<strong style="color: red">*</strong>
                </template>
                </v-text-field>
                
              </v-col>
              
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="getSchema.district_code"
                  persistent-hint
                  required
                  type="number"
                  :rules="generalRules.concat(numberRules)"
                >
                <template v-slot:label>
                  District Code<strong style="color: red">*</strong>
                </template>
                </v-text-field>
                
              </v-col>
            </v-row>
          </v-form>
          </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
           <v-btn color="primary  white--text" @click.stop.prevent="validateBefore()"
            >{{buttonTitle}}</v-btn
          >
          <!-- <v-btn color="primary  white--text" @click.stop.prevent="validationForm()"
            >{{buttonTitle}}</v-btn
          > -->
          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
    <!--     </v-dialog> -->
  </div>
</template>

<script>
import validationRules from "../../mixins/validationRules"
export default {
  // $_veeValidate: {
  //   validator: "new",
  // },
  components: {},
  mixins:[
    validationRules
  ],
  props: ["dialogStatus", "editedData","indexEdited"],
  data: () => ({
    loading: false,
    dialog: false,
    progressShow:false,
  
  }),
  created() {},
  mounted() {
  },
  watch: {
    dialogStatus(val) {
     //  console.log("val sdsd",val);
      this.dialog = val;
      
     
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getDivisionItem() {
      return this.$store.getters.getDivisionItem;
    },
    getSchema() {
      return this.$store.getters.getDistrictSchema;
    },
    
    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Create New District"
        : "Edit New District ";
    },
    getLoaderStatus(){
      return this.$store.getters.getLoaderStatus;
    }
  },
  methods: {
     validateBefore() {
      let valid = this.$refs.formVal.validate()
      if(valid){
        this.validationForm();
      }
    },
   save() {
      let self = this;
      // this.progressShow = true;
      let item =this.getSchema;
      this.$store
        .dispatch("saveDistrictData", item)
        .then(function (data) {
          // self.progressShow = false;
          try {

            self.close();
        
             self.$emit("callReget", true);
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function () {
        });
      
    },
    edit() {
      let self = this;
      let item =this.getSchema;
      this.$store
        .dispatch("editDistrictData", item)
        .then(function(data) {
          
          self.close();
          self.$emit("update:loadData", true);
          self.$emit("callReget", false);
        })
        .catch(function(error) {
         //  console.log(error);
         
        });
      this.$emit('saveText', -1);
    },
   
    close() {
      this.$store.commit("SET_LOADER", false);
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },
 
    validationForm() {
     
          return this.indexEdited === -1 ? this.save() : this.edit();
      
    },
    clear() {
      this.$refs.formVal.reset();
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.fixWidth{
  width: auto;
}
.beside-drop-down{
  margin-top: 10px;
}
</style>
